import storage from "../store";
const setMode = () =>{
    const isDev = import.meta.env.DEV;
    storage.set('__mode__',isDev.toString());
}

setMode();